"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.styled = void 0;
var React = __importStar(require("react"));
function styled(Component) {
    var configs = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        configs[_i - 1] = arguments[_i];
    }
    var preparedConfig = prepareConfig(configs);
    var styledComponent = React.forwardRef(function (props, ref) {
        var className = React.useMemo(function () {
            var resolvedProps = __assign(__assign({}, preparedConfig.defaultProps), props);
            // Add variant classes
            var classNames = preparedConfig.variantProps.reduce(function (acc, propName) {
                var propValue = propName in resolvedProps ? resolvedProps[propName] : undefined;
                if (String(propValue) in preparedConfig.variantClasses[propName]) {
                    return acc.concat(preparedConfig.variantClasses[propName][String(propValue)]);
                }
                return acc;
            }, preparedConfig.defaultClassNames.concat(props.className ? props.className.split(' ') : []));
            // Add composite variant classes
            classNames = preparedConfig.compoundVariants.reduce(function (acc, cv) {
                var className = cv.className, variantProps = __rest(cv, ["className"]);
                // If all compound variable props match, add the classNames
                return Object.keys(variantProps).every(function (propName) {
                    return String(resolvedProps[propName]) === String(variantProps[propName]);
                })
                    ? acc.concat(className)
                    : acc;
            }, classNames);
            return unique(classNames).join(' ');
        }, preparedConfig.variantProps.map(function (p) { return props[p]; }).concat([props.className]));
        var forwardProps = React.useMemo(function () {
            var baseProps = preparedConfig.strippedProps.length > 0
                ? omit(props, preparedConfig.strippedProps)
                : props;
            return __assign(__assign({}, baseProps), { ref: ref, className: className });
        }, [props, ref, className]);
        return React.createElement(Component, forwardProps);
    });
    styledComponent.displayName = getDisplayName(Component);
    return styledComponent; // TODO: Figure out how to type this properly
}
exports.styled = styled;
function getDisplayName(component) {
    var innerName = typeof component === 'string'
        ? component
        : component.displayName || component.name || 'Component';
    return "styled.".concat(innerName);
}
// Merges the provided configurations into a single configuration
function prepareConfig(configs) {
    var combinedConfigs = configs.reduce(function (acc, config) {
        if (typeof config === 'string') {
            return __assign(__assign({}, acc), { defaultClassNames: acc.defaultClassNames.concat(config.split(' ')) });
        }
        else {
            return __assign(__assign({}, acc), { variantProps: config.variants
                    ? acc.variantProps.concat(Object.keys(config.variants))
                    : acc.variantProps, forwardProps: config.forwardProps
                    ? acc.forwardProps.concat(config.forwardProps)
                    : acc.forwardProps, defaultProps: config.defaultVariants
                    ? __assign(__assign({}, acc.defaultProps), config.defaultVariants) : acc.defaultProps, variantClasses: config.variants
                    ? Object.keys(config.variants).reduce(function (vacc, variantName) {
                        var _a;
                        return __assign(__assign({}, vacc), (_a = {}, _a[variantName] = Object.entries(
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        config.variants[variantName]).reduce(function (valueAcc, _a) {
                            var _b;
                            var value = _a[0], className = _a[1];
                            if (!(String(value) in valueAcc)) {
                                valueAcc[String(value)] = className
                                    .split(' ')
                                    .filter(function (c) { return c; });
                            }
                            return __assign(__assign({}, valueAcc), (_b = {}, _b[String(value)] = __spreadArray(__spreadArray([], (String(value) in valueAcc
                                ? valueAcc[String(value)]
                                : []), true), className.split(' ').filter(function (c) { return c; }), true), _b));
                        }, acc.variantClasses[variantName] || {}), _a));
                    }, acc.variantClasses)
                    : acc.variantClasses, compoundVariants: config.compoundVariants
                    ? __spreadArray(__spreadArray([], acc.compoundVariants, true), config.compoundVariants.map(function (cv) { return (__assign(__assign({}, cv), { className: cv.className.split(' ') })); }), true) : acc.compoundVariants });
        }
    }, {
        defaultClassNames: [],
        variantClasses: {},
        strippedProps: [],
        variantProps: [],
        forwardProps: [],
        defaultProps: {},
        compoundVariants: [],
    });
    return __assign(__assign({}, combinedConfigs), { forwardProps: unique(combinedConfigs.forwardProps), variantProps: unique(combinedConfigs.variantProps), defaultClassNames: unique(combinedConfigs.defaultClassNames), strippedProps: unique(combinedConfigs.variantProps.filter(function (p) { return !combinedConfigs.forwardProps.includes(p); })) });
}
/**
 * Creates a new object without the specified keys
 *
 * @param obj
 * @param keys
 * @returns
 */
function omit(obj, keys) {
    var newObj = __assign({}, obj);
    keys.forEach(function (key) { return delete newObj[key]; });
    return newObj;
}
function unique(array) {
    return array.filter(function (item, index, arr) {
        return arr.indexOf(item) === index;
    });
}
